import React, {
  FC, useEffect, useState,
} from 'react';
import {
  RowCenter,
} from './Styles';
import Header from '../../../../Common/Header';
import { Cab, ParcelUser } from '../../../../../../lib/types';
import { getCabId32Str, getWindowWidth, isMobile, isNotEmpty, lang } from '../../../../../../lib/utils/utils';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import { Column } from '../../../../Common/Logo/Styles';
import PingFangMediumText from '../../../../../../components/Text/PingFangMediumText';
import ColumnCenter from '../../../../../../components/Layout/ColumnCenter';
import Button from '../../../../../../components/Button';
import InterMediumItalicText from '../../../../../../components/Text/InterMediumItalicText';
import InterRegularText from '../../../../../../components/Text/InterRegularText';
import InterMediumText from '../../../../../../components/Text/InterMediumText';
import InterBoldText from '../../../../../../components/Text/InterBoldText';
import TermsConditionsModal from '../../../../Common/TermsConditionsModal';
import InterSemiBoldText from '../../../../../../components/Text/InterSemiBoldText';
import PingFangSemiBoldText from '../../../../../../components/Text/PingFangSemiBoldText';

const SuccessContent: FC<Props> = ({
  onClose,
  isEnglish,
  setIsEnglish,
  cab,
  orderIdList,
  cabOrderBoxMap,
  userId,
  openBoxes,
  registerUserInfo,
}) => {
  const width = isMobile() ? getWindowWidth() - 40 : 400;
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setShowTermsModal(false);
            }}
            showAgreeBtn={false}
            showExitBtn={false}
            isEnglish={isEnglish}
          />
        )
      }
      <Column style={{ alignItems: isMobile() ? undefined : 'center' }}>
        <div style={{ width: isMobile() ? '100%' : 400 }}>
          {/* 头部 */}
          <Header
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            style={{ marginTop: '20px' }}
            onClose={onClose}
            showSupport={true}
            supportIsOnlyCall={true}
            cabId32Str={getCabId32Str(cab.cabId)}
          />

          <ColumnCenter style={{ marginTop: 40, width, marginLeft: 'auto', marginRight: 'auto' }}>
            {/* 标题 */}
            {
              lang(
                <InterMediumItalicText fontSize={24} lineHeight={29} marginTop={10}>
                  You are all set!
                </InterMediumItalicText>,
                <PingFangMediumText fontSize={24} lineHeight={29} marginTop={10}>
                  您已成功注册！
                </PingFangMediumText>
              )
            }
            {
              lang(
                <InterRegularText fontSize={14} lineHeight={20} textAlign={'center'} marginTop={10} wordNewline={true}>
                  You’ll receive an <InterSemiBoldText isSpan={true} color={'#00D2B9'} fontSize={14}>SMS</InterSemiBoldText> from Foodifox<br />Smart Locker with a <InterSemiBoldText isSpan={true} color={'#00D2B9'} fontSize={14}>pick-up QR code</InterSemiBoldText><br /><InterSemiBoldText isSpan={true} color={'#00D2B9'} fontSize={14}>link</InterSemiBoldText> once your delivery arrives.
                </InterRegularText>,
                <PingFangRegularText fontSize={14} lineHeight={20} textAlign={'center'} marginTop={10}>
                  您的外卖或快递送达后，您将收到Foodifox<br />智能柜发来的一条<PingFangSemiBoldText isSpan={true} color={'#00D2B9'} fontSize={14}>短信</PingFangSemiBoldText>，其中包含取件<br /><PingFangSemiBoldText isSpan={true} color={'#00D2B9'} fontSize={14}>二维码链接</PingFangSemiBoldText>。
                </PingFangRegularText>
              )
            }
            <ColumnCenter style={{ borderRadius: 5, backgroundColor: 'rgba(228, 228, 228, 0.5)', marginTop: 25, width: '100%' }}>
              {
                lang(
                  <InterMediumText fontSize={14} lineHeight={20} marginTop={20}>
                    Your current deliveries in locker:
                  </InterMediumText>,
                  <PingFangMediumText fontSize={14} lineHeight={20} marginTop={20}>
                    您当前可取的订单数量：
                  </PingFangMediumText>
                )
              }
              <RowCenter style={{ backgroundColor: '#FFFFFF', borderRadius: 5, width: 152, height: 55, marginTop: 10 }}>
                <InterBoldText fontSize={22} color={'#11202B'}>
                  {orderIdList.length > 0 && orderIdList.length < 10 ? '0' : ''}{orderIdList.length}
                </InterBoldText>
              </RowCenter>

              {
                Object.keys(cabOrderBoxMap || {}).map((cabId: any) => {
                  const boxCount = cabOrderBoxMap?.[cabId].boxCount;
                  const orderBoxList = cabOrderBoxMap?.[cabId].orderBoxList;
                  if (!boxCount || !orderBoxList || orderBoxList.length === 0) {
                    return;
                  }
                  return (
                    <InterMediumText fontSize={14} lineHeight={20} marginTop={10}>
                      MT{boxCount} Door: <InterMediumText isSpan={true} fontSize={14} lineHeight={20} color={'#00D2B9'}>{orderBoxList.sort((a, b) => parseInt(a) - parseInt(b)).map((boxNumber) => (parseInt(boxNumber) < 10 ? `0${boxNumber}` : boxNumber)).join(', ')}</InterMediumText>
                    </InterMediumText>
                  );
                })
              }

              {/* 打开柜门 */}
              <Button
                marginTop={10}
                marginBottom={20}
                minWidth={165}
                minHeight={45}
                disabled={orderIdList.length === 0}
                backgroundColor={orderIdList.length === 0 ? '#E4E4E4' : '#00D2B9'}
                borderRadius={5}
                onClick={() => {
                  if (orderIdList.length === 0) {
                    return;
                  }
                  openBoxes(orderIdList, userId);
                }}
              >
                {
                  lang(
                    <InterMediumText fontSize={18} color={'#FFFFFF'}>
                      Open door
                    </InterMediumText>,
                    <PingFangMediumText fontSize={18} color={'#FFFFFF'}>
                      立即开门
                    </PingFangMediumText>
                  )
                }
              </Button>
            </ColumnCenter>
          </ColumnCenter>

          {/* 用户信息 */}
          <Column style={{ marginTop: 30, width, marginLeft: 'auto', marginRight: 'auto', marginBottom: 50 }}>
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width}>
                  Your details
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width}>
                  您的信息
                </PingFangMediumText>
              )
            }
            {/* 分隔线 */}
            <div style={{ width: '100%', height: 1, backgroundColor: '#000000', opacity: 0.5, marginTop: 10 }} />
            {/* 地址名称 */}
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width} marginTop={10}>
                  Building address
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width} marginTop={10}>
                  地址名称
                </PingFangMediumText>
              )
            }
            <InterRegularText fontSize={12} lineHeight={15} width={width} maxWidth={width} wordNewline={true}>
              {cab.cabName}
            </InterRegularText>
            {/* 送餐姓名 */}
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  Delivery names
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  配送姓名
                </PingFangMediumText>
              )
            }
            <InterRegularText fontSize={12} lineHeight={15} width={width} maxWidth={width} wordNewline={true}>
              {registerUserInfo?.userNameList?.filter(({ userName }) => isNotEmpty(userName)).map(({ userName }) => userName)?.join(',')}
            </InterRegularText>
            {/* 门牌号 */}
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  Unit/Apartment number
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  公寓/门牌号
                </PingFangMediumText>
              )
            }
            <InterRegularText fontSize={12} lineHeight={15} width={width} maxWidth={width} wordNewline={true}>
              {registerUserInfo?.roomNo || '-'}
            </InterRegularText>
            {/* 邮箱地址 */}
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  Email address
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  邮箱地址
                </PingFangMediumText>
              )
            }
            <InterRegularText fontSize={12} lineHeight={15} width={width} maxWidth={width} wordNewline={true}>
              {registerUserInfo?.email || '-'}
            </InterRegularText>
            {/* 手机号码 */}
            {
              lang(
                <InterMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  Contact number
                </InterMediumText>,
                <PingFangMediumText fontSize={14} lineHeight={22} width={width} marginTop={15}>
                  联系电话
                </PingFangMediumText>
              )
            }
            <InterRegularText fontSize={12} lineHeight={15} width={width} maxWidth={width} wordNewline={true}>
              +{registerUserInfo?.phoneNumber}
            </InterRegularText>
          </Column>

          {/*<RowCenter style={{ position: 'fixed', bottom: 0, paddingBottom: 10, paddingTop: 5, width: '100%', backgroundColor: '#FFFFFF' }}>*/}
          {/*  <Button onClick={() => setShowTermsModal(true)}>*/}
          {/*    <InterMediumItalicText fontSize={12} textDecorationLine={'underline'}>*/}
          {/*      Terms of use and Privacy Policy*/}
          {/*    </InterMediumItalicText>*/}
          {/*  </Button>*/}
          {/*</RowCenter>*/}
        </div>
      </Column>
    </>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  orderIdList: number[];
  cabOrderBoxMap?: { [key: number]: { boxCount: number; orderBoxList: string[] } };
  setShowLoading: (isShow: boolean) => void;
  userId?: number;
  openBoxes: (orderIdList: number[], userId?: number) => void;
  registerUserInfo?: ParcelUser;
}

export default SuccessContent;
